import { render, staticRenderFns } from "./TicketByCategories.vue?vue&type=template&id=ce23c3f0&scoped=true&"
import script from "./TicketByCategories.vue?vue&type=script&lang=js&"
export * from "./TicketByCategories.vue?vue&type=script&lang=js&"
import style0 from "./TicketByCategories.vue?vue&type=style&index=0&id=ce23c3f0&lang=scss&scoped=true&"
import style1 from "./TicketByCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce23c3f0",
  null
  
)

export default component.exports